module.exports = "/assets/ee6bdc75183ddb18b60c9937072b4a47.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/FB.png
// module id = 1364
// module chunks = 0